import React from 'react';
import { motion } from 'framer-motion';
export function DeviceMockup() {
  return <div className="relative w-full max-w-md mx-auto aspect-square flex items-center justify-center mt-8 lg:mt-0" data-id="element-26">
      {/* iPad Mockup */}
      <motion.div initial={{
      opacity: 0,
      x: 30
    }} animate={{
      opacity: 1,
      x: 0
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} className="absolute right-0 top-0 w-[80%] aspect-[3/4] bg-gray-900 rounded-[2rem] p-3 shadow-2xl border-4 border-gray-800 z-10" data-id="element-27">
        <div className="w-full h-full bg-gradient-to-br from-navy to-navy-dark rounded-xl overflow-hidden relative flex flex-col items-center justify-center p-8 text-center shadow-inner" data-id="element-28">
          {/* Decorative Background Elements */}
          <div className="absolute top-0 left-0 w-full h-40 bg-orange opacity-20 transform -skew-y-12 origin-top-left" data-id="element-29"></div>
          <div className="absolute bottom-0 right-0 w-40 h-40 bg-orange opacity-10 rounded-tl-full" data-id="element-30"></div>

          {/* eBook Cover Content */}
          <h3 className="font-heading font-extrabold text-white text-3xl md:text-4xl mb-4 z-10 leading-tight tracking-tight" data-id="element-31">
            FINANÇAS
            <br data-id="element-32" />
            SOB CONTROLE
          </h3>
          <div className="w-20 h-1.5 bg-orange mb-8 z-10 rounded-full" data-id="element-33"></div>
          <p className="text-gray-light font-body font-medium tracking-widest uppercase text-xs md:text-sm z-10" data-id="element-34">
            George Capital
            <br data-id="element-35" />
            Coaching
          </p>
        </div>
      </motion.div>

      {/* iPhone Mockup */}
      <motion.div initial={{
      opacity: 0,
      x: -30,
      y: 30
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} transition={{
      duration: 0.8,
      delay: 0.3,
      ease: 'easeOut'
    }} className="absolute left-0 bottom-4 w-[45%] aspect-[9/19] bg-gray-900 rounded-[2.5rem] p-2 shadow-2xl border-4 border-gray-800 z-20" data-id="element-36">
        <div className="w-full h-full bg-gradient-to-br from-navy to-navy-dark rounded-[2rem] overflow-hidden relative flex flex-col items-center justify-center p-4 text-center shadow-inner" data-id="element-37">
          {/* Notch */}
          <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-[40%] h-5 bg-gray-900 rounded-b-xl z-30" data-id="element-38"></div>

          {/* Decorative Background Elements */}
          <div className="absolute top-0 left-0 w-full h-24 bg-orange opacity-20 transform -skew-y-12 origin-top-left" data-id="element-39"></div>
          <div className="absolute bottom-0 right-0 w-24 h-24 bg-orange opacity-10 rounded-tl-full" data-id="element-40"></div>

          {/* eBook Cover Content */}
          <h3 className="font-heading font-extrabold text-white text-xl mb-2 z-10 leading-tight tracking-tight mt-4" data-id="element-41">
            FINANÇAS
            <br data-id="element-42" />
            SOB CONTROLE
          </h3>
          <div className="w-10 h-1 bg-orange mb-4 z-10 rounded-full" data-id="element-43"></div>
          <p className="text-gray-light font-body font-medium tracking-widest uppercase text-[9px] z-10" data-id="element-44">
            George Capital
            <br data-id="element-45" />
            Coaching
          </p>
        </div>
      </motion.div>
    </div>;
}